<script setup lang="ts">
import { zhCN, dateZhCN, enUS, dateEnGB, zhTW, dateZhTW } from "naive-ui"
import { apiSetAPiLang } from "./api/lang"

const { locale, setLocale, locales, getBrowserLocale, t } = useI18n()

zhCN.Input.placeholder = "请输入关键字"
enUS.Input.placeholder = "Please enter a keyword"
zhTW.Input.placeholder = "請輸入關鍵字"
zhCN.Select.placeholder = "请按关键词搜索"
enUS.Select.placeholder = "Please search by keyword"
zhTW.Select.placeholder = "請按關鍵字搜索"

const lang = computed(() => {
    const lang = locale.value
    if (lang === "zh-cn") {
        return zhCN
    }
    if (lang === "en") {
        return enUS
    }
    if (lang === "zh-tw") {
        return zhTW
    }
    return enUS
})

const dateLang = computed(() => {
    const lang = locale.value
    if (lang === "zh-cn") {
        return dateZhCN
    }
    if (lang === "en") {
        return dateEnGB
    }
    if (lang === "zh-tw") {
        return dateZhTW
    }
    return dateEnGB
})

const router = useRouter()
const route = useRoute()
const blocale = getBrowserLocale()
let queryLang = route.query.locale as string | undefined
let currentLang = ref<string | undefined>(blocale ? blocale : "en")
if (queryLang) {
    currentLang.value = {
        zh_CN: "zh-cn",
        en_US: "en",
        zh_TW: "zh-tw",
    }[queryLang]
}
watch(
    () => router.currentRoute.value.query.locale,
    async (v) => {
        console.log("[预约] query.locale:" + v)
        if (v) {
            currentLang.value = {
                zh_CN: "zh-cn",
                en_US: "en",
                zh_TW: "zh-tw",
            }[v as string]
        }
    },
    {
        immediate: true,
    },
)

// const allow = locales.value.map((v) => {
//     return typeof v === "string" ? v : v.code
// })

watch(
    currentLang,
    async (v) => {
        console.log("[预约] currentLang:" + v)
        const langValue = v ?? "en"
        await setLocale(langValue).then(() => {
            useDayjs().locale((v as string) === "en" ? "en-sg" : (v as string))
            const lang = {
                en: "enUs",
                "zh-cn": "zhCn",
                "zh-tw": "zhHant",
            }[langValue as "en" | "zh-cn" | "zh-tw"]
            apiSetAPiLang(lang ?? "enUs").catch(() => {})
        })
        locale.value = langValue
    },
    {
        immediate: true,
    },
)
</script>

<template>
    <NConfigProvider
        :theme="null"
        :theme-overrides="useThemeOverrides"
        :locale="lang"
        :date-locale="dateLang"
        abstract
        inline-theme-disabled
    >
        <NGlobalStyle />
        <NEl>
            <NuxtLayout>
                <NuxtPage />
            </NuxtLayout>
        </NEl>
    </NConfigProvider>
</template>
